import { push } from '@lagunovsky/redux-react-router'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import FormRegister from '../../components/Forms/FormRegister/FormRegister'
import Typography from '../../components/Typography/Typography'
import useErrorMessage from '../../components/Windows/InfoWindow/hooks/useErrorMessage'

import hocConnect from './hocConnect'

import './Register.scss'

const Register = ({ isAuth, error, register, registerSocialsError }) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    const errorMessage = useErrorMessage(error?.message)

    if (isAuth) dispatch(push('/user-profile'))

    return (
        <Container fluid className="d-flex flex-column">
            <div className={'register-page d-flex flex-column'}>
                <Typography variant={'h2'}>{intl.formatMessage({ id: 'forms.register.title' })}</Typography>

                <FormRegister
                    handleSubmit={(values, withMemberAccount) => register({ user: values, withMemberAccount })}
                    handleSocialsError={registerSocialsError}
                />
            </div>

            <img
                src={'images/cinestar/astronaut-with-mobile.png'}
                alt={'astronaut-with-mobile'}
                className={'astronaut-animate h-auto w-25 mx-auto mt-16'}
            />
        </Container>
    )
}

export default hocConnect(Register)
